import React, { useContext, useState } from "react";
import roboResponde from "./img/robo-conecta-responde.svg";
import ThumbUpIcon from "@material-ui/icons/ThumbUpAltOutlined";
import ThumbDownIcon from "@material-ui/icons/ThumbDownAltOutlined";
import FileCopyIcon from "@material-ui/icons/FileCopyOutlined";
import CheckIcon from "@material-ui/icons/Check";
import AppContext from "../appContext";
import { formatTime, getNomeUsuario, getIniciaisUsuario } from "./repondeur-utils";
import { renderMarkdown } from "./markdown-lite";

const copyText = async text => {
	try {
		if (navigator.clipboard && navigator.clipboard.writeText) {
			await navigator.clipboard.writeText(text);
			return true;
		}
	} catch (e) {}
	try {
		const area = document.createElement("textarea");
		area.value = text;
		area.style.position = "fixed";
		area.style.opacity = "0";
		document.body.appendChild(area);
		area.select();
		document.execCommand("copy");
		document.body.removeChild(area);
		return true;
	} catch (e) {
		return false;
	}
};

const ChatMessage = ({ msg, onFeedback }) => {
	const context = useContext(AppContext);
	const [score, setScore] = useState(null);
	const [comment, setComment] = useState("");
	const [sending, setSending] = useState(false);
	const [failed, setFailed] = useState(false);
	const [copied, setCopied] = useState(false);

	const nomeUsuario = getNomeUsuario();
	const avatarUsuario = context && context.avatar;

	const canRate = msg.from === "bot" && msg.text && !msg.feedbackSent;
	const canCopy = msg.from !== "system" && !!msg.text;
	const actionsActive = copied || score !== null || msg.feedbackSent;

	const submitFeedback = async () => {
		setSending(true);
		setFailed(false);
		const ok = await onFeedback(msg.id, score, comment);
		setSending(false);
		if (!ok) setFailed(true);
	};

	const handleCopy = async () => {
		const ok = await copyText(msg.text);
		if (ok) {
			setCopied(true);
			setTimeout(() => setCopied(false), 1500);
		}
	};

	return (
		<div
			className={
				"repondeur-message repondeur-message-" +
				msg.from +
				(actionsActive ? " actions-active" : "")
			}
		>
			{msg.from === "bot" && (
				<div className="repondeur-avatar" aria-hidden="true">
					<img className="repondeur-avatar-robo" src={roboResponde} alt="" />
				</div>
			)}

			<div className="repondeur-message-content">
				{msg.from !== "system" && (
					<span className="repondeur-author">
						{msg.from === "bot" ? "Conecta Responde" : nomeUsuario || "Você"}
					</span>
				)}
				<div className="repondeur-bubble">{msg.from === "bot" ? renderMarkdown(msg.text, true) : msg.text}</div>

				{msg.from !== "system" && (
					<div className="repondeur-actions">
						{canCopy && (
							<button
								type="button"
								className="repondeur-action-btn"
								onClick={handleCopy}
								aria-label="Copiar mensagem"
							>
								{copied ? <CheckIcon fontSize="inherit" /> : <FileCopyIcon fontSize="inherit" />}
							</button>
						)}
						{canRate && (
							<>
								<button
									type="button"
									className={"repondeur-action-btn" + (score === 1 ? " selected" : "")}
									onClick={() => setScore(1)}
									aria-label="Resposta útil"
								>
									<ThumbUpIcon fontSize="inherit" />
								</button>
								<button
									type="button"
									className={"repondeur-action-btn" + (score === 0 ? " selected" : "")}
									onClick={() => setScore(0)}
									aria-label="Resposta não útil"
								>
									<ThumbDownIcon fontSize="inherit" />
								</button>
							</>
						)}
						{msg.at && <span className="repondeur-time">{formatTime(msg.at)}</span>}
					</div>
				)}

				{canRate && score !== null && (
					<div className="repondeur-feedback-form">
						<p className="repondeur-feedback-titulo">
							{score === 1 ? "O que ajudou nesta resposta?" : "O que poderia melhorar?"}
							<span> Opcional</span>
						</p>
						<div className="repondeur-feedback-campo">
							<input
								type="text"
								value={comment}
								maxLength={500}
								autoFocus
								placeholder={
									score === 1 ? "Ex.: foi direto ao ponto" : "Ex.: faltou o prazo de entrega"
								}
								onChange={event => setComment(event.target.value)}
								onKeyDown={event => {
									if (event.key === "Enter" && !sending) submitFeedback();
								}}
							/>
							<button
								type="button"
								className="repondeur-feedback-cancelar"
								onClick={() => setScore(null)}
							>
								Cancelar
							</button>
							<button
								type="button"
								className="repondeur-feedback-enviar"
								disabled={sending}
								onClick={submitFeedback}
							>
								{sending ? "Enviando..." : "Enviar"}
							</button>
						</div>
						{failed && (
							<span className="repondeur-feedback-error">Não foi possível enviar. Tente novamente.</span>
						)}
					</div>
				)}

				{msg.feedbackSent && <div className="repondeur-feedback-done">Avaliação enviada</div>}
			</div>

			{msg.from === "user" && (
				<div className="repondeur-avatar repondeur-avatar-user" aria-hidden="true">
					{avatarUsuario ? <img src={avatarUsuario} alt="" /> : getIniciaisUsuario() || "EU"}
				</div>
			)}
		</div>
	);
};

export default React.memo(ChatMessage);
